import { render, staticRenderFns } from "./AccountDropdown.vue?vue&type=template&id=2a96776c&scoped=true"
import script from "./AccountDropdown.vue?vue&type=script&lang=js"
export * from "./AccountDropdown.vue?vue&type=script&lang=js"
import style0 from "./AccountDropdown.vue?vue&type=style&index=0&id=2a96776c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a96776c",
  null
  
)

export default component.exports